module.exports = __webpack_public_path__ + "img/Wp_2015.3f53ecab.png";